import CustomProvider from 'components/CustomProvider';
import { defineMessages } from '@alltrails/shared/react-intl';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import Dandelion from '@alltrails/shared/illustrations/Dandelion';
import NullState from '@alltrails/shared/denali/components/NullState';

type Props = {
  isCurrentUser: boolean;
};

const messages = defineMessages({
  REVIEW_SOME_TRAILS: {
    defaultMessage: 'Review some trails'
  },
  REVIEW_SUBTEXT: {
    defaultMessage: 'Help others know what to expect from the trail by sharing your experience.'
  },
  EXPLORE_TRAILS: {
    defaultMessage: 'Explore trails'
  },
  NO_REVIEWS_YET: {
    defaultMessage: 'No reviews yet'
  }
});

const UserEmptyReviews = ({ isCurrentUser }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { REVIEW_SOME_TRAILS, REVIEW_SUBTEXT, EXPLORE_TRAILS, NO_REVIEWS_YET }
  } = useFormatMessage(messages);

  const onExploreTrails = () => {
    if (!window) {
      return;
    }

    window.location.href = '/explore';
  };

  return (
    <NullState
      illustration={{ Component: Dandelion }}
      title={isCurrentUser ? REVIEW_SOME_TRAILS : NO_REVIEWS_YET}
      description={REVIEW_SUBTEXT}
      buttons={isCurrentUser ? { primary: { text: EXPLORE_TRAILS, testId: 'explore-trails', onClick: onExploreTrails } } : undefined}
    />
  );
};

export default function UserEmptyReviewsWrapper({ isCurrentUser }: Props) {
  return (
    <CustomProvider>
      <UserEmptyReviews isCurrentUser={isCurrentUser} />
    </CustomProvider>
  );
}
